module.exports = {
	xs: '450px',
	sm: '600px',
	md: '1024px',
	lg: '1366px'
}